import React, { useState, useEffect, useContext } from 'react';
import { Badge, Button, Stack } from 'react-bootstrap';
import { useFilter } from '../filterContext/FilterContext';
import { ContentContext } from '../content/ContentContext';

const PopularTagsStack = () => {
  const [tags, setTags] = useState([]);
  const { filterTag, setFilterTag } = useFilter();
  const { content } = useContext(ContentContext);

  // Fetch popular tags from the server
  const fetchPopularTags = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/tags`); // Ensure this matches your backend route
      const data = await response.json();
      setTags(data);
    } catch (error) {
      console.error('Error fetching popular tags:', error);
    }
  };

  useEffect(() => {
    fetchPopularTags();

    // Optionally, set an interval to refresh the popular tags every 60 seconds
    const intervalId = setInterval(fetchPopularTags, 60000);

    return () => clearInterval(intervalId); // Clean up on unmount
  }, []);

  const handleTagClick = (tag) => {
    if (tag === filterTag) {
      setFilterTag(null);
      return;
    }
    setFilterTag(tag); // Directly passing the tag object from map
  };

  const handleDisableAllTags = () => {
    setFilterTag(null);
  }

  return (
    //Center the tags
    <div className="col-md-5 d-flex flex-column justif-content-center w-100">
      <Badge
        bg="primary"
        className="mx-5 mb-3 p-2 text-center" // Bootstrap's text-center class centers the text
        style={{
          fontSize: "15px",
          display: "block",        // Ensures the badge takes up the full width
          flex: "1",           // Full width to allow text centering within it
          whiteSpace: "normal",    // Allows text to wrap
          wordWrap: "break-word",  // Breaks long words onto a new line if necessary
        }}
      >
        Sorteaza discutiile din forum dupa etichetele
      </Badge>
      {tags.map((tag, index) => (
        <Badge
          bg={tag.tag === filterTag && content === "PostList" ? "success" : "secondary"}
          key={index}
          className="p-2 mb-2 mx-auto"
          onClick={() => content === "PostList" ? handleTagClick(tag.tag) : {}}
          style={{ cursor: content === "PostList" ? "pointer" : "", width: 'fit-content' }}
        >
          {tag.tag} <Badge bg='white' style={{ color: 'black' }} className='rounded-circle'>{tag.popularity}</Badge>
        </Badge>
      ))}
      <Button variant='danger' onClick={handleDisableAllTags} className='mx-auto btn-sm'>Vezi toate discutiile din forum</Button>
    </div>
  );
};

export default PopularTagsStack;
